export enum OperatorStatus {
  OFFLINE = 'OFFLINE',
  AWAY = 'AWAY',
  AVAILABLE = 'AVAILABLE'
}
